import React, { useState, useRef, useEffect, useCallback } from 'react';
import { FaChevronDown, FaTimes } from 'react-icons/fa';
import { useGetCategoryQuery, useGetCategoryListByIdsMutation } from '../../../Services/CategoryApi';
import debounce from 'lodash.debounce';

const CategoryDropdown = ({
    selectedCategoryIds,
    prevState,
    toggleCategorySelection,
    setDeletedCategoryIds,
    setNewCategoryIds
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [reloadCount, setReloadCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const limit = 50;

    const dropdownRef = useRef(null);
    const scrollRef = useRef(null);

    const [categories, setCategories] = useState([]);

    const { data, isFetching, isSuccess } = useGetCategoryQuery({ search, page, limit });
    const [mutate] = useGetCategoryListByIdsMutation();

    useEffect(() => {
        if (!selectedCategoryIds || selectedCategoryIds.length === 0) return;
        if (reloadCount > 0) return;
        setIsLoading(true)
        mutate({ categoryIds: selectedCategoryIds }).then((response) => {
            console.log({ response })
            if (response.data.statusCode === 200) {
                setCategories(prev => {
                    const newCategories = response.data.data.filter(
                        item => !prev.some(existing => existing._id === item._id) // or use 'name' or another unique key
                    );
                    return [...prev, ...newCategories];
                });
                setReloadCount(prev => prev + 1);
                setIsLoading(false)
            }

        }).finally(() => {
            setIsLoading(false)
        })
    }, [selectedCategoryIds])
    useEffect(() => {
        if (isSuccess) {
            setCategories(prev =>
                page === 1 ? data.data.categories : [...prev, ...data.data.categories]
            );
        }
    }, [data, isSuccess, page]);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleScroll = () => {
        if (
            scrollRef.current &&
            scrollRef.current.scrollTop + scrollRef.current.clientHeight >= scrollRef.current.scrollHeight - 10 &&
            !isFetching &&
            data?.data?.categories?.length === limit
        ) {
            setPage(prev => prev + 1);
        }
    };

    const debouncedSearch = useCallback(debounce((val) => setSearch(val), 400), []);

    const handleSearchChange = (e) => {
        debouncedSearch(e.target.value);
    };

    const handleToggle = ({ checked, id }) => {
        toggleCategorySelection(id);

        if (checked) {
            setDeletedCategoryIds(prev => prev.filter(prevId => prevId !== id));

            if (!prevState.includes(id)) {
                setNewCategoryIds(prev => (prev.includes(id) ? prev : [...prev, id]));
            }
        } else {
            setNewCategoryIds(prev => prev.filter(prevId => prevId !== id));

            if (prevState.includes(id)) {
                setDeletedCategoryIds(prev => (prev.includes(id) ? prev : [...prev, id]));
            }
        }
    };

    return (
        <div className="position-relative" ref={dropdownRef}>
            <div
                className="form-control d-flex justify-content-between align-items-center"
                onClick={() => setIsOpen(prev => !prev)}
                style={{ cursor: 'pointer' }}
            >
                <span>{selectedCategoryIds.length > 0 ? `${selectedCategoryIds.length} selected` : 'Select Categories'}</span>
                <FaChevronDown />
            </div>

            {isOpen && (
                <div
                    className="position-absolute bg-white border shadow rounded mt-1 p-3"
                    style={{ zIndex: 1000, width: '100%', maxHeight: '300px', overflowY: 'auto' }}
                    ref={scrollRef}
                    onScroll={handleScroll}
                >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <strong>Categories</strong>
                        <FaTimes style={{ cursor: 'pointer' }} onClick={() => setIsOpen(false)} />
                    </div>

                    <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Search categories..."
                        onChange={handleSearchChange}
                    />

                    {categories.map((category) => (
                        <div className="form-check" key={category._id}>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`dropdown-cat-${category._id}`}
                                checked={selectedCategoryIds.includes(category._id)}
                                onChange={(e) => handleToggle({ checked: e.target.checked, id: category._id })}
                            />
                            <label className="form-check-label" htmlFor={`dropdown-cat-${category._id}`}>
                                {category.name}
                            </label>
                        </div>
                    ))}

                    {isFetching || isLoading && <div className="text-center py-2">Loading...</div>}
                </div>
            )}
        </div>
    );
};

export default CategoryDropdown;
